import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Grid, Divider, Button, Card, Typography } from "@material-ui/core"
import MaterialDataGrid from "../../components/MaterialDataGrid"
import {
  renderOnSave,
  renderOnEdit,
  renderOnDiscard,
  renderSwitchHandler,
  renderItemChange,
  renderSelectionChange,
  renderSetDefaultValue,
  renderHeaderSelectionChange,
  renderUpdateTableFilterData,
  renderSingleSelectionChange,
} from "./renderProps"
import * as Adm from "@adm"
import { useHistory } from "react-router-dom"

function TableLocation(props) {
  const { t } = useTranslation()
  const {
    isGrid = false,
    tableGlobalState,
    pageData,
    detailPageRoute,
    reDirectPath,
    queryParams = "",
    onRowClick,
    DontGoToUrl,
    deleteAnId,
    editVariable,
    isType = "singel",
    InTableRowEdit,
    onSaveHandler,
    additionalActions = () => {},
    ShowCheckBox = true,
    isOnRowClick = true,
    loading,
    hideCheckboxAll = false,
    isLookup = false,
    pageable = true,
    actionMenu = true,
  } = props || {}

  const { isWriteAllowed } = props

  const {
    setGridState,
    gridState,
    items,
    setRowData,
    rowData,
    scrollable = "scrollable",
  } = tableGlobalState
  const { columnData } = tableGlobalState

  let history = useHistory()

  return (
    <Grid lg={12} md={12} sm={12} xs={12}>
      <Grid item>
        <MaterialDataGrid
          isGrid={isGrid}
          isInlineEditAllowed={isWriteAllowed}
          additionalActions={additionalActions}
          itemChange={(event) => renderItemChange(event, tableGlobalState)}
          isLookup={isLookup}
          scrollable={scrollable}
          setDefaultValue={(event, props) =>
            renderSetDefaultValue(event, props, tableGlobalState)
          }
          headerSelectionChange={(event) =>
            renderHeaderSelectionChange(event, tableGlobalState)
          }
          selectionChange={(event) =>
            hideCheckboxAll
              ? renderSingleSelectionChange(event, tableGlobalState)
              : renderSelectionChange(event, tableGlobalState)
          }
          onDiscard={(props) =>
            renderOnDiscard(props, tableGlobalState, InTableRowEdit)
          }
          onEdit={(props) =>
            DontGoToUrl
              ? onRowClick(props)
              : renderOnEdit(
                  props,
                  history,
                  tableGlobalState,
                  reDirectPath,
                  editVariable,
                  isType,
                  InTableRowEdit,
                  queryParams
                )
          }
          onDelete={(props) => {
            deleteAnId(props)
          }}
          onSave={(props) =>
            InTableRowEdit
              ? onSaveHandler(props, tableGlobalState)
              : renderOnSave(props, tableGlobalState)
          }
          switchHandler={(event, props) =>
            renderSwitchHandler(event, props, tableGlobalState)
          }
          setGridState={setGridState}
          gridState={gridState}
          setRowData={setRowData}
          rowData={rowData}
          columnData={columnData}
          pathProps={detailPageRoute}
          pageData={pageData}
          actionMenu={true}
          number_of_items={items}
          onRowClick={props?.onRowClick}
          menutype={props.menutype}
          ShowCheckBox={ShowCheckBox}
          isOnRowClick={isOnRowClick}
          hideCheckboxAll={hideCheckboxAll}
          pageable={pageable}
        />
      </Grid>
    </Grid>
  )
}
export { TableLocation }
